// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import { ClearFormError, SetFormError } from '@actions/formError';

interface FormErrorsState {
  [form: string]: string;
}

interface SetFormErrorPayload {
  form: string;
  error: string;
}

type SetFormErrorAction = Action<SetFormErrorPayload>;

const initialState: FormErrorsState = {};

export default handleActions<FormErrorsState, SetFormErrorPayload | void>(
  {
    [SetFormError.toString()]: (
      state: FormErrorsState,
      { payload }: SetFormErrorAction,
    ): FormErrorsState => {
      return {
        ...state,
        [payload.form]: payload.error,
      };
    },
    [ClearFormError.toString()]: (): FormErrorsState => {
      return initialState;
    },
  },
  initialState,
);
